import { useCallback } from 'react';
import { useMutation } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';

import { AcademyFormInput } from '../types/form';

import { updateAcademyMutation, UpdateAcademyMutationResult, UpdateAcademyMutationVariables } from '../graphql/mutations/updateAcademyMutation';

interface AcademyActionsHookOutput {
  onUpdateAcademy: (input: AcademyFormInput, onSuccess: () => void) => void;
  updateAcademyLoading: boolean;
  updateAcademyError?: string;
}

export default function useAcademyActions(): AcademyActionsHookOutput {
  const [updateAcademy, { loading: updateAcademyLoading, error: updateAcademyError }] = useMutation<
    UpdateAcademyMutationResult,
    UpdateAcademyMutationVariables
  >(updateAcademyMutation);
  const onUpdateAcademy = useCallback(
    (input: AcademyFormInput, onSuccess: () => void) => {
      updateAcademy({
        variables: { input },
      }).then(onSuccess);
    },
    [updateAcademy]
  );

  return {
    onUpdateAcademy,
    updateAcademyLoading,
    updateAcademyError: getErrorMessage({ error: updateAcademyError }),
  };
}
